import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";

import { GridSortItem } from "@mui/x-data-grid";

import { RootState } from "App/Store";

import { SortOrderType } from "Common/Enums";

import { ISortByParams } from "Types/EVaultAppTypes";

import { fetchPackages, updateSearchBarParams, updateSortBy } from "./InactiveLoansSlice";
import { getInactiveMersPackagesUrl } from "./inactiveLoanAdapters";

export function executeSearch(): ThunkAction<void, RootState, unknown, AnyAction> {
  return async (dispatch, getState) => {
    const state: RootState = getState();
    const data = state.inactiveLoans.searchBarParams.data;
    const searchParams = {
      ...data,
      searchTerm: data.searchTerm?.trim(),
    };
    dispatch(updateSearchBarParams(searchParams));
    dispatch(fetchInactiveLoans());
  };
}

export function updateSortByAction({ field, sort }: GridSortItem): ThunkAction<void, RootState, unknown, AnyAction> {
  return async (dispatch, getState) => {
    // Return if missing necessary arguments
    if (!field || !sort) return;

    const { sortField: prevSortField, sortOrderType: prevSortOrderType } = getState().inactiveLoans.sortByParams;
    const newSortOrderType = sort === "asc" ? SortOrderType.ASCENDING : SortOrderType.DESCENDING;

    // If no sort property changes, exit without fetching new data
    if (prevSortField === field && prevSortOrderType === newSortOrderType) return;

    const newSortOrderParams: ISortByParams = {
      sortField: field,
      sortOrderType: newSortOrderType,
    };
    dispatch(updateSortBy(newSortOrderParams));
    dispatch(fetchInactiveLoans());
  };
}

export function fetchInactiveLoans(resourceUrl?: string): ThunkAction<void, RootState, unknown, AnyAction> {
  return async (dispatch, getState) => {
    const state: RootState = getState();
    if (resourceUrl) {
      dispatch(fetchPackages(resourceUrl));
    } else {
      const searchCriteria = state.inactiveLoans.searchBarParams.data;
      const sortByParams = state.inactiveLoans.sortByParams;
      const params = {
        ...searchCriteria,
        limit: 100,
        offset: 0,
        sortByParams,
      };
      const url = getInactiveMersPackagesUrl(params);
      dispatch(fetchPackages(url));
    }
  };
}
